export default __webpack_public_path__ + "static/media/colombian.4ddb4938.png";